<template>
    <component :is="galleryComponent" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { mapGetters } from 'vuex';
import GalleryDefault from './gallery/GalleryDefault.vue';
import GalleryType1   from './gallery/GalleryType1.vue';
import GalleryType2   from './gallery/GalleryType2.vue';
import GalleryType3   from './gallery/GalleryType3.vue';
import GalleryType4   from './gallery/GalleryType4.vue';
import GalleryType5   from './gallery/GalleryType5.vue';
import GalleryType6   from './gallery/GalleryType6.vue';
import GalleryType7   from './gallery/GalleryType7.vue';

const THEME_MAP = {
    type_1: 'GalleryType1',
    type_2: 'GalleryType2',
    type_3: 'GalleryType3',
    type_4: 'GalleryType4',
    type_5: 'GalleryType5',
    type_6: 'GalleryType6',
    type_7: 'GalleryType7',
};

export default {
    name: 'ProductGallery',
    inheritAttrs: false,
    components: {
        GalleryDefault,
        GalleryType1,
        GalleryType2,
        GalleryType3,
        GalleryType4,
        GalleryType5,
        GalleryType6,
        GalleryType7,
    },
    computed: {
        ...mapGetters('auth', ['shopTheme']),
        galleryComponent() {
            return THEME_MAP[this.shopTheme] || 'GalleryDefault';
        },
    },
};
</script>
